import React, { Component } from 'react'
import { Action } from 'hljd'
import { observer } from 'mobx-react'
const Item = Action.Item

@observer
export default class extends Component {
  render() {
    const { activeTab, changeTab, list } = this.props.store
    const { seed, viewed, finished } = list || {}
    return (
      <Action
        active={activeTab}
        onChange={changeTab}
        style={{ marginBottom: 26 }}
        itemStyle={{ fontSize: 14 }}
      >
        <Item value="seed">已发送({(seed || []).length})</Item>
        <Item value="viewed">已查看({(viewed || []).length})</Item>
        <Item value="finished">转为客资({(finished || []).length})</Item>
      </Action>
    )
  }
}
